module.exports = __webpack_public_path__ + "img/reviewer-bg.d959a480.svg";